import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    id: "projects",
    class: "w-full"
};
const _hoisted_2 = { class: "mb-16 md:flex justify-between items-end" };
const _hoisted_3 = { class: "flex flex-col" };
const _hoisted_4 = { class: "text-sm font-mono uppercase tracking-widest opacity-50 mb-4" };
const _hoisted_5 = { class: "relative inline-flex bg-gray-100 dark:bg-white/10" };
const _hoisted_6 = ["href"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "min-w-0 flex-grow" };
const _hoisted_10 = { class: "text-xs md:text-sm opacity-60 leading-relaxed mt-0.5" };
const _hoisted_11 = { class: "flex items-center gap-1.5 mt-1" };
const _hoisted_12 = { class: "font-mono uppercase tracking-widest text-xs opacity-70" };
const _hoisted_13 = {
    key: 1,
    class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "relative aspect-[16/10] overflow-hidden" };
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = { class: "absolute top-4 left-4 flex gap-2" };
const _hoisted_18 = { class: "inline-block px-3 py-1 bg-white/90 dark:bg-black/80 text-black dark:text-white text-xs font-mono font-bold backdrop-blur-sm" };
const _hoisted_19 = { class: "absolute top-4 right-4 w-10 h-10 bg-accent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 -translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0" };
const _hoisted_20 = { class: "absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/80 to-transparent" };
const _hoisted_21 = { class: "text-2xl md:text-2xl font-black text-white tracking-tight leading-tight uppercase" };
const _hoisted_22 = { class: "p-5" };
const _hoisted_23 = { class: "text-sm opacity-70 leading-relaxed mb-4" };
const _hoisted_24 = { class: "flex flex-wrap gap-2" };
const _hoisted_25 = {
    key: 2,
    href: "https://gitgud.lnln.eu/u/maskalix",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "group mb-6 flex items-center gap-4 border border-black/10 dark:border-white/10 bg-white dark:bg-white/5 p-4 md:p-5 hover:border-accent dark:hover:border-accent transition-colors duration-300"
};
const _hoisted_26 = { class: "min-w-0 flex-grow" };
const _hoisted_27 = { class: "font-bold tracking-tight text-base md:text-lg leading-tight" };
const _hoisted_28 = { class: "font-mono text-sm opacity-50" };
const _hoisted_29 = { class: "text-xs md:text-sm opacity-60 leading-relaxed mt-0.5" };
const _hoisted_30 = { class: "flex items-center gap-1.5 mt-1" };
const _hoisted_31 = {
    key: 3,
    class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
};
const _hoisted_32 = ["href"];
const _hoisted_33 = { class: "relative aspect-[16/10] overflow-hidden bg-gray-900 flex items-center justify-center" };
const _hoisted_34 = { class: "absolute top-4 left-4 flex gap-2" };
const _hoisted_35 = { class: "inline-block px-3 py-1 bg-white/90 dark:bg-black/80 text-black dark:text-white text-xs font-mono font-bold backdrop-blur-sm" };
const _hoisted_36 = {
    key: 0,
    class: "inline-flex items-center gap-1 px-3 py-1 bg-white/90 dark:bg-black/80 text-black dark:text-white text-xs font-mono font-bold backdrop-blur-sm"
};
const _hoisted_37 = { class: "absolute top-4 right-4 w-10 h-10 bg-accent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 -translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0" };
const _hoisted_38 = { class: "absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/80 to-transparent" };
const _hoisted_39 = { class: "text-2xl md:text-2xl font-black text-white tracking-tight leading-tight uppercase" };
const _hoisted_40 = { class: "p-5" };
const _hoisted_41 = { class: "text-sm opacity-70 leading-relaxed mb-4" };
const _hoisted_42 = { class: "flex flex-wrap gap-2" };
const _hoisted_43 = {
    key: 4,
    href: "https://lnln.eu",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "group mb-6 flex items-center gap-4 border border-black/10 dark:border-white/10 bg-white dark:bg-white/5 p-4 md:p-5 hover:border-accent dark:hover:border-accent transition-colors duration-300"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = ["src"];
const _hoisted_46 = { class: "min-w-0 flex-grow" };
const _hoisted_47 = { class: "text-xs md:text-sm opacity-60 leading-relaxed mt-0.5" };
const _hoisted_48 = { class: "flex items-center gap-1.5 mt-1" };
const _hoisted_49 = {
    key: 5,
    class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
};
const _hoisted_50 = ["href"];
const _hoisted_51 = { class: "relative aspect-[16/10] overflow-hidden bg-gray-900 flex items-center justify-center" };
const _hoisted_52 = { class: "absolute top-4 left-4 flex gap-2" };
const _hoisted_53 = { class: "inline-flex items-center gap-1 px-3 py-1 bg-white/90 dark:bg-black/80 text-black dark:text-white text-xs font-mono font-bold backdrop-blur-sm" };
const _hoisted_54 = { class: "absolute top-4 right-4 w-10 h-10 bg-accent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 -translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0" };
const _hoisted_55 = { class: "absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/80 to-transparent" };
const _hoisted_56 = { class: "text-2xl md:text-2xl font-black text-white tracking-tight leading-tight uppercase" };
const _hoisted_57 = { class: "p-5" };
const _hoisted_58 = { class: "text-sm opacity-70 leading-relaxed mb-4" };
const _hoisted_59 = { class: "flex flex-wrap gap-2" };
const _hoisted_60 = {
    key: 6,
    class: "border border-black/10 dark:border-white/10 py-16 px-6 flex flex-col items-center text-center gap-5"
};
const _hoisted_61 = { class: "text-sm opacity-60 max-w-md leading-relaxed" };
const _hoisted_62 = ["href"];
const _hoisted_63 = {
    key: 7,
    class: "mt-10 flex justify-center"
};
const _hoisted_64 = { class: "text-sm font-mono uppercase tracking-widest" };
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from "vue";
import { Icon } from "@iconify/vue";
import { PROJECTS_DATA, CONTENT } from "../constants";
import { useLanguage } from "../composables/useLanguage";
import githubSeed from "../data/github-repos.json";
import lnlnAppsSeed from "../data/lnln-apps.json";
import gitgudSeed from "../data/gitgud-score.json";
import lnlnLogoDark from "../lnln_b.svg"; // dark mark, for light backgrounds
import lnlnLogoLight from "../lnln_w.svg"; // light mark, for dark backgrounds
import socenLogoDark from "../socen_light.png"; // dark mark, for light backgrounds
import socenLogoLight from "../socen_dark.png"; // light mark, for dark backgrounds
const GITHUB_USER = "maskalix";
const CACHE_KEY = "gh-repos-cache-v2";
const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours
// Map raw GitHub API repos -> Project[]: own (non-fork), non-archived, newest first.
export default /*@__PURE__*/ _defineComponent({
    __name: 'Projects',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        // Socials Century uses a per-locale TLD: .com (en), .cz (cz), .eu (de).
        const socenDomain = computed(() => {
            const tld = { en: "com", cz: "cz", de: "eu" }[language.value] ?? "com";
            return `socialscentury.${tld}`;
        });
        const socenUrl = computed(() => `https://${socenDomain.value}`);
        // Seeded with a bundled snapshot so the tab is never blank, even on a cold,
        // rate-limited load. Replaced by live data as soon as a fetch succeeds.
        const githubRepos = ref(githubSeed);
        const lnlnApps = ref(lnlnAppsSeed);
        // GitGud score parsed from the badge SVG. Seeded with a committed snapshot
        // (also parsed from the SVG) so it renders instantly; a live re-parse runs on
        // mount and updates it when reachable.
        const gitgud = ref(gitgudSeed);
        const loading = ref(true);
        const activeTab = ref("projects");
        const projectsExpanded = ref(false);
        const githubExpanded = ref(false);
        const lnlnExpanded = ref(false);
        const isMobile = ref(false);
        const updateIsMobile = () => {
            isMobile.value = window.innerWidth < 768;
        };
        const defaultVisibleCount = computed(() => (isMobile.value ? 3 : 6));
        const expandedVisibleCount = computed(() => (isMobile.value ? 6 : 12));
        // Tab refs for dynamic slider positioning
        const projectsTabRef = ref(null);
        const githubTabRef = ref(null);
        const lnlnTabRef = ref(null);
        const sliderLeft = ref(0);
        const sliderWidth = ref(0);
        const updateSliderPosition = () => {
            const activeRef = {
                projects: projectsTabRef.value,
                github: githubTabRef.value,
                lnln: lnlnTabRef.value,
            }[activeTab.value];
            if (activeRef) {
                sliderLeft.value = activeRef.offsetLeft;
                sliderWidth.value = activeRef.offsetWidth;
            }
        };
        const sliderStyle = computed(() => ({
            left: `${sliderLeft.value}px`,
            width: `${sliderWidth.value}px`,
        }));
        watch(activeTab, () => {
            nextTick(updateSliderPosition);
        });
        watch(language, () => {
            nextTick(updateSliderPosition);
        });
        onMounted(() => {
            nextTick(updateSliderPosition);
            // Tab labels reflow once the web font (Inter) finishes loading, which leaves
            // the red indicator measured against the wider fallback font. Re-measure when
            // fonts are ready, and on resize, so it always matches the active tab.
            if (document.fonts?.ready) {
                document.fonts.ready.then(() => updateSliderPosition());
            }
            window.addEventListener("resize", updateSliderPosition);
        });
        onUnmounted(() => {
            window.removeEventListener("resize", updateSliderPosition);
        });
        // Merge projects with Czech as fallback for missing fields
        const mergedProjects = computed(() => {
            const czProjects = PROJECTS_DATA["cz"];
            const currentProjects = PROJECTS_DATA[language.value];
            return currentProjects.map((project, index) => {
                const czProject = czProjects.find((p) => p.id === project.id) || czProjects[index];
                return {
                    ...czProject,
                    ...project,
                    // Ensure these fields use Czech fallback if not defined
                    image: project.image || czProject?.image || "",
                    year: project.year || czProject?.year || "",
                    link: project.link || czProject?.link || "",
                };
            });
        });
        // Sort projects by year (newest first)
        const sortedProjects = computed(() => {
            return [...mergedProjects.value].sort((a, b) => {
                const yearA = parseInt((a.year || "0").split(/[–-]/)[0].trim());
                const yearB = parseInt((b.year || "0").split(/[–-]/)[0].trim());
                return yearB - yearA;
            });
        });
        const visibleProjects = computed(() => {
            if (projectsExpanded.value) {
                return sortedProjects.value.slice(0, expandedVisibleCount.value);
            }
            return sortedProjects.value.slice(0, defaultVisibleCount.value);
        });
        // GitHub repos sorted by stars (most first), newest year as the tie-break
        const sortedGithubRepos = computed(() => {
            return [...githubRepos.value].sort((a, b) => {
                const byStars = (b.stars ?? 0) - (a.stars ?? 0);
                if (byStars !== 0)
                    return byStars;
                const yearA = parseInt((a.year || "0").split(/[–-]/)[0].trim());
                const yearB = parseInt((b.year || "0").split(/[–-]/)[0].trim());
                return yearB - yearA;
            });
        });
        const visibleGithubRepos = computed(() => {
            if (githubExpanded.value) {
                return sortedGithubRepos.value.slice(0, expandedVisibleCount.value);
            }
            return sortedGithubRepos.value.slice(0, defaultVisibleCount.value);
        });
        // LNLN apps: live ones first, then keep the authored order within each group.
        const sortedLnlnApps = computed(() => {
            return [...lnlnApps.value].sort((a, b) => Number(b.live ?? false) - Number(a.live ?? false));
        });
        const visibleLnlnApps = computed(() => {
            if (lnlnExpanded.value) {
                return sortedLnlnApps.value.slice(0, expandedVisibleCount.value);
            }
            return sortedLnlnApps.value.slice(0, defaultVisibleCount.value);
        });
        const currentListLength = computed(() => {
            if (activeTab.value === "projects")
                return sortedProjects.value.length;
            if (activeTab.value === "lnln")
                return sortedLnlnApps.value.length;
            return sortedGithubRepos.value.length;
        });
        const isExpanded = computed(() => {
            if (activeTab.value === "projects")
                return projectsExpanded.value;
            if (activeTab.value === "lnln")
                return lnlnExpanded.value;
            return githubExpanded.value;
        });
        const toggleExpanded = () => {
            if (activeTab.value === "projects") {
                projectsExpanded.value = !projectsExpanded.value;
            }
            else if (activeTab.value === "lnln") {
                lnlnExpanded.value = !lnlnExpanded.value;
            }
            else {
                githubExpanded.value = !githubExpanded.value;
            }
        };
        const mapRepos = (data) => data
            .filter((repo) => !repo.archived && !repo.fork)
            .sort((a, b) => new Date(b.created_at).getTime() -
            new Date(a.created_at).getTime())
            .map((repo) => {
            const createdYear = new Date(repo.created_at).getFullYear();
            const lastUpdateYear = new Date(repo.pushed_at).getFullYear();
            const yearRange = createdYear === lastUpdateYear
                ? createdYear.toString()
                : `${createdYear} – ${lastUpdateYear}`;
            return {
                id: `gh-${repo.id}`,
                title: repo.name,
                description: repo.description || "A GitHub repository.",
                techStack: [repo.language || "Code", "GitHub"],
                image: "",
                year: yearRange,
                link: repo.html_url,
                stars: repo.stargazers_count,
            };
        });
        // Live fetch — refreshes the list + cache, but never blanks the UI on failure.
        const fetchGithubRepos = async () => {
            try {
                const response = await fetch(`https://api.github.com/users/${GITHUB_USER}/repos?sort=created&direction=desc&per_page=100`);
                if (!response.ok)
                    throw new Error(`GitHub API ${response.status}`);
                const repos = mapRepos(await response.json());
                if (repos.length) {
                    githubRepos.value = repos;
                    try {
                        localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: repos }));
                    }
                    catch {
                        /* localStorage unavailable — ignore */
                    }
                }
            }
            catch (error) {
                // Rate-limited (403) or offline: keep showing cached/seed repos
                // instead of an empty tab.
                console.warn("GitHub live fetch failed, showing cached/seed repos:", error);
            }
            finally {
                loading.value = false;
            }
        };
        // Cache-first loader: serve cached repos instantly and only hit the API when the
        // cache is stale, so repeated loads and hot-reloads don't burn the 60/hour
        // unauthenticated limit — effectively unrestricted browsing without a token.
        const loadGithubRepos = async () => {
            try {
                const raw = localStorage.getItem(CACHE_KEY);
                if (raw) {
                    const cached = JSON.parse(raw);
                    if (Array.isArray(cached?.data) && cached.data.length) {
                        githubRepos.value = cached.data;
                        if (Date.now() - cached.ts < CACHE_TTL) {
                            loading.value = false;
                            return; // fresh cache — skip the network entirely
                        }
                    }
                }
            }
            catch {
                /* corrupt cache — fall through to a live fetch */
            }
            await fetchGithubRepos();
        };
        // Parse the GitGud badge SVG. Everything we need is in the aria-label, e.g.
        // aria-label="Polyglot: A · 79/100", plus the grade accent color on the first
        // <rect>. Returns null if the SVG doesn't match the expected shape.
        const parseGitgudBadge = (svg) => {
            const label = svg.match(/aria-label="([^:"]+):\s*([^·"]+?)\s*·\s*(\d+)\/(\d+)"/);
            if (!label)
                return null;
            const color = svg.match(/<rect[^>]*x="14"[^>]*fill="(#[0-9a-fA-F]{3,8})"/);
            return {
                title: label[1].trim(),
                tier: label[2].trim(),
                score: Number(label[3]),
                max: Number(label[4]),
                color: color?.[1] ?? gitgud.value.color,
            };
        };
        // Best-effort live re-parse of the badge. Cross-origin reads may be blocked
        // (the badge endpoint sends no CORS header), in which case we keep the seed.
        const loadGitgudScore = async () => {
            try {
                const res = await fetch(`https://gitgud.lnln.eu/api/badge/${GITHUB_USER}@light~swiss.svg`);
                if (!res.ok)
                    throw new Error(`GitGud badge ${res.status}`);
                const parsed = parseGitgudBadge(await res.text());
                if (parsed)
                    gitgud.value = parsed;
            }
            catch (error) {
                // CORS-blocked or offline: keep the committed snapshot.
                console.warn("GitGud live parse failed, showing seed score:", error);
            }
        };
        onMounted(() => {
            loadGithubRepos();
            loadGitgudScore();
            updateIsMobile();
            window.addEventListener("resize", updateIsMobile);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createCommentVNode(" Header with Tab Switcher "),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", _hoisted_4, _toDisplayString(text.value.sections.work), 1 /* TEXT */),
                        _createCommentVNode(" Tab Switcher "),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                ref_key: "projectsTabRef",
                                ref: projectsTabRef,
                                onClick: _cache[0] || (_cache[0] = ($event) => (activeTab.value = 'projects')),
                                class: _normalizeClass(["relative z-10 px-4 py-2 text-xs font-mono uppercase tracking-widest transition-colors duration-300",
                                    activeTab.value === 'projects'
                                        ? 'text-white'
                                        : 'text-black/70 dark:text-white/70 hover:text-black dark:hover:text-white'
                                ])
                            }, _toDisplayString(text.value.sections.selectedWorks), 3 /* TEXT, CLASS */),
                            _createElementVNode("button", {
                                ref_key: "githubTabRef",
                                ref: githubTabRef,
                                onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'github')),
                                class: _normalizeClass(["relative z-10 px-4 py-2 text-xs font-mono uppercase tracking-widest transition-colors duration-300",
                                    activeTab.value === 'github'
                                        ? 'text-white'
                                        : 'text-black/70 dark:text-white/70 hover:text-black dark:hover:text-white'
                                ])
                            }, _toDisplayString(text.value.sections.github), 3 /* TEXT, CLASS */),
                            _createElementVNode("button", {
                                ref_key: "lnlnTabRef",
                                ref: lnlnTabRef,
                                onClick: _cache[2] || (_cache[2] = ($event) => (activeTab.value = 'lnln')),
                                class: _normalizeClass(["relative z-10 px-4 py-2 text-xs font-mono uppercase tracking-widest transition-colors duration-300",
                                    activeTab.value === 'lnln'
                                        ? 'text-white'
                                        : 'text-black/70 dark:text-white/70 hover:text-black dark:hover:text-white'
                                ])
                            }, _toDisplayString(text.value.sections.lnln), 3 /* TEXT, CLASS */),
                            _createElementVNode("div", {
                                class: "absolute top-0 bottom-0 bg-accent transition-all duration-300 ease-out z-0",
                                style: _normalizeStyle(sliderStyle.value)
                            }, null, 4 /* STYLE */)
                        ])
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-[1px] flex-grow bg-black/10 dark:bg-white/10 ml-8 hidden md:block" }, null, -1 /* CACHED */))
                ]),
                _createCommentVNode(" Currently Working Banner (Socials Century) "),
                (activeTab.value === 'projects')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: socenUrl.value,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "group mb-6 flex items-center gap-4 border border-black/10 dark:border-white/10 bg-white dark:bg-white/5 p-4 md:p-5 hover:border-accent dark:hover:border-accent transition-colors duration-300"
                    }, [
                        _createElementVNode("img", {
                            src: _unref(socenLogoDark),
                            alt: "Socials Century logo",
                            class: "w-10 h-10 md:w-12 md:h-12 object-contain shrink-0 block dark:hidden"
                        }, null, 8 /* PROPS */, _hoisted_7),
                        _createElementVNode("img", {
                            src: _unref(socenLogoLight),
                            alt: "Socials Century logo",
                            class: "w-10 h-10 md:w-12 md:h-12 object-contain shrink-0 hidden dark:block"
                        }, null, 8 /* PROPS */, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-bold tracking-tight text-base md:text-lg leading-tight" }, [
                                _createTextVNode(" Socials Century "),
                                _createElementVNode("span", { class: "font-normal text-xs opacity-50 ml-1" }, "Digital studio")
                            ], -1 /* CACHED */)),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(text.value.sections.workingFor), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(socenDomain.value), 1 /* TEXT */),
                                _createVNode(_unref(Icon), {
                                    icon: "ph:arrow-up-right-bold",
                                    class: "w-3 h-3 opacity-50 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                })
                            ])
                        ])
                    ], 8 /* PROPS */, _hoisted_6))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Projects Grid "),
                (activeTab.value === 'projects')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleProjects.value, (project) => {
                            return (_openBlock(), _createElementBlock("a", {
                                key: project.id,
                                href: project.link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "group relative bg-white dark:bg-white/5 overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.2)] dark:hover:shadow-[0_20px_50px_-15px_rgba(255,255,255,0.1)]"
                            }, [
                                _createCommentVNode(" Image Container "),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("img", {
                                        src: project.image,
                                        alt: project.title,
                                        class: "object-cover w-full h-full transition-all duration-700 ease-out group-hover:scale-110"
                                    }, null, 8 /* PROPS */, _hoisted_16),
                                    _createCommentVNode(" Dark Overlay "),
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-500" }, null, -1 /* CACHED */)),
                                    _createCommentVNode(" Year Badge "),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(project.year), 1 /* TEXT */)
                                    ]),
                                    _createCommentVNode(" Arrow Icon "),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_unref(Icon), {
                                            icon: "ph:arrow-up-right-bold",
                                            class: "w-5 h-5 text-white"
                                        })
                                    ]),
                                    _createCommentVNode(" Title Overlay on Image "),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("h4", _hoisted_21, _toDisplayString(project.title), 1 /* TEXT */)
                                    ])
                                ]),
                                _createCommentVNode(" Content "),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(project.description), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.techStack, (tech) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: tech,
                                                class: "text-xs uppercase px-2 py-1 bg-gray-100 dark:bg-white/10 font-medium opacity-70 group-hover:opacity-100 transition-opacity"
                                            }, _toDisplayString(tech), 1 /* TEXT */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]),
                                _createCommentVNode(" Bottom Accent Line "),
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute bottom-0 left-0 right-0 h-1 bg-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" }, null, -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_14));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" GitGud Score banner (score / tier / title parsed from the badge SVG) "),
                (activeTab.value === 'github' && gitgud.value)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_25, [
                        _createCommentVNode(" Tier letter, colored with the grade color parsed from the SVG "),
                        _createElementVNode("span", {
                            class: "w-10 h-10 md:w-12 md:h-12 shrink-0 flex items-center justify-center text-white font-black text-2xl md:text-3xl leading-none",
                            style: _normalizeStyle({ backgroundColor: gitgud.value.color }),
                            "aria-hidden": "true"
                        }, _toDisplayString(gitgud.value.tier), 5 /* TEXT, STYLE */),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", _hoisted_27, [
                                _createTextVNode(_toDisplayString(gitgud.value.title) + " ", 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(gitgud.value.score) + "/" + _toDisplayString(gitgud.value.max), 1 /* TEXT */)
                            ]),
                            _createElementVNode("p", _hoisted_29, _toDisplayString(text.value.sections.gitgudDesc), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_30, [
                                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-mono uppercase tracking-widest text-xs opacity-70" }, "gitgud.lnln.eu", -1 /* CACHED */)),
                                _createVNode(_unref(Icon), {
                                    icon: "ph:arrow-up-right-bold",
                                    class: "w-3 h-3 opacity-50 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                })
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" GitHub Repos Grid "),
                (activeTab.value === 'github')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleGithubRepos.value, (repo) => {
                            return (_openBlock(), _createElementBlock("a", {
                                key: repo.id,
                                href: repo.link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "group relative bg-white dark:bg-white/5 overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.2)] dark:hover:shadow-[0_20px_50px_-15px_rgba(255,255,255,0.1)]"
                            }, [
                                _createCommentVNode(" Image Container "),
                                _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_unref(Icon), {
                                        icon: "mdi:github",
                                        class: "w-20 h-20 text-white/20"
                                    }),
                                    _createCommentVNode(" Dark Overlay "),
                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-500" }, null, -1 /* CACHED */)),
                                    _createCommentVNode(" Year Badge "),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(repo.year), 1 /* TEXT */),
                                        _createCommentVNode(" Star Count "),
                                        (repo.stars !== undefined)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                                _createVNode(_unref(Icon), {
                                                    icon: "ph:star-fill",
                                                    class: "w-3 h-3"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(repo.stars), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createCommentVNode(" Arrow Icon "),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createVNode(_unref(Icon), {
                                            icon: "ph:arrow-up-right-bold",
                                            class: "w-5 h-5 text-white"
                                        })
                                    ]),
                                    _createCommentVNode(" Title Overlay on Image "),
                                    _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("h4", _hoisted_39, _toDisplayString(repo.title), 1 /* TEXT */)
                                    ])
                                ]),
                                _createCommentVNode(" Content "),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("p", _hoisted_41, _toDisplayString(repo.description), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_42, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repo.techStack, (tech) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: tech,
                                                class: "text-xs uppercase px-2 py-1 bg-gray-100 dark:bg-white/10 font-medium opacity-70 group-hover:opacity-100 transition-opacity"
                                            }, _toDisplayString(tech), 1 /* TEXT */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]),
                                _createCommentVNode(" Bottom Accent Line "),
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute bottom-0 left-0 right-0 h-1 bg-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" }, null, -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_32));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" LNLN Subbrand Banner "),
                (activeTab.value === 'lnln')
                    ? (_openBlock(), _createElementBlock("a", _hoisted_43, [
                        _createElementVNode("img", {
                            src: _unref(lnlnLogoDark),
                            alt: "LNLN logo",
                            class: "w-10 h-10 md:w-12 md:h-12 object-contain shrink-0 block dark:hidden"
                        }, null, 8 /* PROPS */, _hoisted_44),
                        _createElementVNode("img", {
                            src: _unref(lnlnLogoLight),
                            alt: "LNLN logo",
                            class: "w-10 h-10 md:w-12 md:h-12 object-contain shrink-0 hidden dark:block"
                        }, null, 8 /* PROPS */, _hoisted_45),
                        _createElementVNode("div", _hoisted_46, [
                            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "font-bold tracking-tight text-base md:text-lg leading-tight" }, [
                                _createTextVNode(" LNLN "),
                                _createElementVNode("span", { class: "font-normal text-xs opacity-50 ml-1" }, "[line by line]")
                            ], -1 /* CACHED */)),
                            _createElementVNode("p", _hoisted_47, _toDisplayString(text.value.sections.lnlnDesc), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_48, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-mono uppercase tracking-widest text-xs opacity-70" }, "lnln.eu", -1 /* CACHED */)),
                                _createVNode(_unref(Icon), {
                                    icon: "ph:arrow-up-right-bold",
                                    class: "w-3 h-3 opacity-50 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                })
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" LNLN Apps Grid "),
                (activeTab.value === 'lnln')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleLnlnApps.value, (app) => {
                            return (_openBlock(), _createElementBlock("a", {
                                key: app.id,
                                href: app.link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "group relative bg-white dark:bg-white/5 overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.2)] dark:hover:shadow-[0_20px_50px_-15px_rgba(255,255,255,0.1)]"
                            }, [
                                _createCommentVNode(" Icon Container "),
                                _createElementVNode("div", _hoisted_51, [
                                    _createVNode(_unref(Icon), {
                                        icon: app.icon || 'ph:app-window',
                                        class: "w-20 h-20 text-white/20 transition-transform duration-700 ease-out group-hover:scale-110"
                                    }, null, 8 /* PROPS */, ["icon"]),
                                    _createCommentVNode(" Dark Overlay "),
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-500" }, null, -1 /* CACHED */)),
                                    _createCommentVNode(" Status Badge "),
                                    _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("span", _hoisted_53, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["w-1.5 h-1.5 rounded-full", app.live ? 'bg-accent' : 'bg-black/40 dark:bg-white/40'])
                                            }, null, 2 /* CLASS */),
                                            _createTextVNode(" " + _toDisplayString(app.live ? "LIVE" : "SOON"), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createCommentVNode(" Arrow Icon "),
                                    _createElementVNode("div", _hoisted_54, [
                                        _createVNode(_unref(Icon), {
                                            icon: "ph:arrow-up-right-bold",
                                            class: "w-5 h-5 text-white"
                                        })
                                    ]),
                                    _createCommentVNode(" Title Overlay on Icon "),
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("h4", _hoisted_56, _toDisplayString(app.title), 1 /* TEXT */)
                                    ])
                                ]),
                                _createCommentVNode(" Content "),
                                _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("p", _hoisted_58, _toDisplayString(app.description), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_59, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(app.techStack, (tech) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: tech,
                                                class: "text-xs uppercase px-2 py-1 bg-gray-100 dark:bg-white/10 font-medium opacity-70 group-hover:opacity-100 transition-opacity"
                                            }, _toDisplayString(tech), 1 /* TEXT */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]),
                                _createCommentVNode(" Bottom Accent Line "),
                                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute bottom-0 left-0 right-0 h-1 bg-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" }, null, -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_50));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" GitHub Empty / Rate-limited Fallback "),
                (activeTab.value === 'github' && githubRepos.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createVNode(_unref(Icon), {
                            icon: "mdi:github",
                            class: "w-14 h-14 opacity-20"
                        }),
                        _createElementVNode("p", _hoisted_61, _toDisplayString(text.value.sections.githubDesc), 1 /* TEXT */),
                        _createElementVNode("a", {
                            href: `https://github.com/${GITHUB_USER}`,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "group flex items-center gap-3 px-6 py-3 border border-black/20 dark:border-white/20 hover:border-accent dark:hover:border-accent transition-colors duration-300"
                        }, [
                            _createElementVNode("span", { class: "text-sm font-mono uppercase tracking-widest" }, " github.com/" + _toDisplayString(GITHUB_USER)),
                            _createVNode(_unref(Icon), {
                                icon: "ph:arrow-up-right-bold",
                                class: "w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            })
                        ], 8 /* PROPS */, _hoisted_62)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Show More / Show Less Button "),
                (currentListLength.value > defaultVisibleCount.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("button", {
                            onClick: toggleExpanded,
                            class: "group flex items-center gap-3 px-6 py-3 border border-black/20 dark:border-white/20 hover:border-accent dark:hover:border-accent transition-colors duration-300"
                        }, [
                            _createElementVNode("span", _hoisted_64, _toDisplayString(isExpanded.value
                                ? text.value.sections.showLess
                                : text.value.sections.showMore), 1 /* TEXT */),
                            _createVNode(_unref(Icon), {
                                icon: isExpanded.value ? 'ph:caret-up-bold' : 'ph:caret-down-bold',
                                class: "w-4 h-4 transition-transform duration-300"
                            }, null, 8 /* PROPS */, ["icon"])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
